export default __webpack_public_path__ + "static/media/line-h-18.02c12ceb.png";